import React, { Component } from 'react';
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import styled from 'styled-components';
import { ErrorMessage } from './styles';

const SelectBox = styled.div`
  position: relative;
  min-height: 80px;
  width: 100%;

  .Dropdown-menu {
    max-height: 145px;
  }

  .Dropdown-control {
    padding: 11px 50px 11px 15px;
    width: 100%;
    border: 1px solid #ccc;
    cursor: pointer;
  }

  .Dropdown-placeholder {
    min-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .labelSpan {
    display: block;
    margin-bottom: 5px;
    font-size: 14px;
    cursor: pointer;
  }

  .Dropdown-arrow {
    top: 50%;
    right: 10px;
    transform: translate(0, -50%);
  }
`;

class Select extends Component {
  state = {
    selectValue: ''
  };

  render() {
    const { input, meta, label, options, placeholder, onChangeCompetition, index } = this.props;

    return (
      <SelectBox>
        <label className="labelSpan">{label}</label>
        <Dropdown
          options={options || []}
          {...input}
          onChange={(value) => {
            input.onChange(value);
            input.onBlur();
            if (input.value.value !== value.value) {
              onChangeCompetition && onChangeCompetition(index);
            }
          }}
          value={input.value}
          placeholder={placeholder || 'Select an option'}
        />

        {meta.touched && meta.error && (
          <ErrorMessage show={meta.touched && meta.error}>{meta.error}</ErrorMessage>
        )}
      </SelectBox>
    );
  }
}

export default Select;
